import React, { useMemo } from 'react';
import { CustomColumn } from '../../../../types/components/tables/tableTypes';
import { DataObject } from '../../../../types/redux/data/dataTypes';
import GridItem from '../../../layout/GridComponents/GridItem';
import CustomTable from '../../../tables/CustomTable';
import {
  SifOverviewData,
  generateSifOverviewColumns,
  generateSifOverviewData,
} from './Overview.data';
import { useDemoFundIds } from '../../../../hooks/useDemoFundIds';
import { demoRowStyle } from '../../../../utilities/demoFundUtils';
import { useSelector } from 'react-redux';
import { activeSectionSelector } from '../../../../redux/pages/selectors';

interface DeceasedTableProps {
  reportsData: DataObject;
  tableData: DataObject;
  pageId?: string;
}

const DeceasedTable: React.FC<DeceasedTableProps> = (props) => {
  const section = useSelector(activeSectionSelector);
  const demoFundIds = useDemoFundIds(section || 'sif-raif', props.pageId);
  const columns: CustomColumn<SifOverviewData>[] = generateSifOverviewColumns();
  const data = useMemo(
    () =>
      generateSifOverviewData(
        props.tableData.data[0],
        props.reportsData,
        demoFundIds,
      ),
    [props.tableData, props.reportsData, demoFundIds],
  );

  return (
    <GridItem card xs={12}>
      <CustomTable<SifOverviewData>
        //   csvFields={ucitsOverviewCsvFields}
        showToolbar
        toolbarComponents={{
          toolbarTitle: 'Deceased Data',
        }}
        columns={columns}
        data={data}
        options={{
          paging: false,
          pageSize: 10,
          pageSizeOptions: [10, 20, data.length],
          search: true,
          exportButton: true,
          rowStyle: demoRowStyle<SifOverviewData>({ padding: '0.62rem' }),
        }}
      />
    </GridItem>
  );
};

export default DeceasedTable;
